import { useApi } from './api';
import { URLS } from '../constants/urls';

export function useUsuarioService() {
    const { authenticatedFetch, publicFetch } = useApi();

    const criarUsuario = async (dados) => {
        const response = await authenticatedFetch(URLS.CREATE_USUARIO, {
            method: 'POST',
            body: JSON.stringify(dados),
        });

        return response.json();
    };

    const atualizarUsuario = async (dados) => {
        const response = await authenticatedFetch(URLS.UPDATE_USUARIO, {
            method: 'POST',
            body: JSON.stringify(dados),
        });

        return response.json();
    };

    const gerarCodigoRecuperacaoUsuario = async (dados) => {
        const response = await publicFetch(URLS.GEN_COD_RECUPERACAO_USUARIO, {
            method: 'POST',
            body: JSON.stringify(dados),
        });

        return response.json();
    };

    const alterarSenhaUsuario = async (dados) => {
        const response = await publicFetch(URLS.VER_COD_RECUPERACAO_USUARIO, {
            method: 'POST',
            body: JSON.stringify(dados),
        });

        return response.json();
    };

    const deletarUsuario = async (id) => {
        const response = await authenticatedFetch(URLS.DELETE_USUARIO, {
            method: 'POST',
            body: JSON.stringify({ id }),
        });

        return response.json();
    };

    const listarTodosUsuarios = async () => {
        const response = await authenticatedFetch(URLS.READ_ALL_USUARIO, {
            method: 'POST',
        });

        return response.json();
    };

    const obterUsuarioPorId = async (id) => {
        const response = await authenticatedFetch(URLS.READ_BY_ID_USUARIO, {
            method: 'POST',
            body: JSON.stringify({ id }),
        });

        return response.json();
    };

    const obterUsuarioPorNome = async (nome) => {
        const response = await authenticatedFetch(URLS.READ_BY_NAME_USUARIO, {
            method: 'POST',
            body: JSON.stringify({ nome }),
        });

        return response.json();
    };

    const listarProdutosDoUsuario = async (idUser) => {
        const response = await authenticatedFetch(URLS.READ_BY_USER_ID_PRODUTO_USUARIO, {
            method: 'POST',
            body: JSON.stringify({ idUser }),
        });

        return response.json();
    };

    const assinarProduto = async (dados) => {
        const response = await authenticatedFetch(URLS.ASSINA_PRODUTO, {
            method: 'POST',
            body: JSON.stringify(dados),
        });

        return response.json();
    };

    const cancelarAssinaturaProduto = async (dados) => {
        const response = await authenticatedFetch(URLS.ASSINA_PRODUTO_DELETE, {
            method: 'POST',
            body: JSON.stringify(dados),
        });

        return response.json();
    };

    return {
        criarUsuario,
        atualizarUsuario,
        gerarCodigoRecuperacaoUsuario,
        alterarSenhaUsuario,
        deletarUsuario,
        listarTodosUsuarios,
        obterUsuarioPorId,
        obterUsuarioPorNome,
        listarProdutosDoUsuario,
        assinarProduto,
        cancelarAssinaturaProduto,
    };
}